import MyProfileView from "@features/profiles/view/my-profiles-view";

const MyProfiles = () => {
  return <MyProfileView />;
};

export default MyProfiles;
